export default __webpack_public_path__ + "static/media/Play-Button.657dfb0c.svg";